import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { blockUi } from '@bndes/bndes-ux4/bndes-angular-utils';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import {
  RenunciaLimiteAdicional,
  JanelaLimiteAdicionalResponse
} from 'src/app/model/renuncia-limite-adicional.model';
import { LimiteAdicionalTrancheAgenteFinanceiro } from 'src/app/model/limite-adicional-tranche-agente-financeiro.model';

@Injectable({ providedIn: 'root' })
export class RenunciaLimiteAdicionalService extends FgiBackEndService<RenunciaLimiteAdicional> {

  getNewEntity() {
    return undefined;
  }

  protected getResourceURL(): string {
    return 'front/renuncia-limite-adicional';
  }

  public getJanelaAtiva(): Observable<JanelaLimiteAdicionalResponse> {
    return this.http.get(`${this.BASE_URL}/janela-ativa`).pipe(
      catchError((e) => this.handleError(e))
    ) as Observable<JanelaLimiteAdicionalResponse | null>;
  }

  public getJanelas(): Observable<JanelaLimiteAdicionalResponse[]> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/janelas`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<JanelaLimiteAdicionalResponse[]>;
  }

  public buscarRenuncias(ideAgente?: number, ideTranche?: number, ideJanela?: number, ideLimiteAdicionalPorTrancheAgenteFinanceiro?: number): Observable<RenunciaLimiteAdicional[]> {
    
    const options = blockUi();
    let params = new HttpParams();
    params = params
      .set('ideAgente', ideAgente != null ? String(ideAgente) : '-1');
    if (ideTranche != null) {
      params = params.set('ideTranche', String(ideTranche));
    }
    if (ideJanela != null) {
      params = params.set('ideJanela', String(ideJanela));
    }
    if (ideLimiteAdicionalPorTrancheAgenteFinanceiro != null) {
      params = params.set('ideLimiteAdicionalPorTrancheAgenteFinanceiro', String(ideLimiteAdicionalPorTrancheAgenteFinanceiro));
    }
    return this.http.get(`${this.BASE_URL}/renuncias`, { ...options, params }).pipe(
      catchError((e) => this.handleError(e))) as Observable<RenunciaLimiteAdicional[]>;
  }

  public getValorDisponivel(ideLimiteAdicionalPorTrancheAgenteFinanceiro: number): Observable<number> {
    const options = blockUi();
    const params = new HttpParams()
      .set('ideLimiteAdicionalPorTrancheAgenteFinanceiro', String(ideLimiteAdicionalPorTrancheAgenteFinanceiro));
    return this.http.get(`${this.BASE_URL}/valor-disponivel`, { ...options, params }).pipe(
      catchError((e) => this.handleError(e))) as Observable<number>;
  }

  public solicitar(dados: any): Observable<void> {
    const options = blockUi();

    return this.http
      .post(`${this.BASE_URL}/solicitar`, dados, options)
      .pipe(
        catchError((e) => this.handleError(e))
      ) as Observable<void>;
  }

  public existeSolicitacao(ideAgente: number): Observable<boolean> {
    const options = blockUi();
    const params = new HttpParams().set('ideAgente', String(ideAgente));
    return this.http.get(`${this.BASE_URL}/solicitacao-existente`, { ...options, params }).pipe(
      catchError((e) => this.handleError(e))) as Observable<boolean>;
  }

  public excluir(ideRenuncia: number): Observable<void> {
    let params = new HttpParams();

    params = params.append('ideRenuncia', String(ideRenuncia));

    // blockUi devolve { headers, params }, entao os params vao POR DENTRO dele:
    // espalhar o retorno depois de um params proprio sobrescreve o nosso com {}.
    return this.http.post(`${this.BASE_URL}/excluir`, null, blockUi({ params })).pipe(
      catchError((e) => this.handleError(e))
    ) as Observable<void>;
  }

  public gerarRelatorioLimiteAdicional(idJanela: number) {
    return this.http.get(`${this.BASE_URL}/apuracao-limite-adicional/${idJanela}`).pipe(
      catchError((e) => this.handleError(e))
    ) as Observable<RenunciaLimiteAdicional[]>;
  }


  public getLimiteAdicionalPermitido(ideAgente?: number) {
    const options = blockUi();
    let params = new HttpParams();

    if (ideAgente != null) {
      params = params.set('ideAgente', ideAgente.toString());
    }

    return this.http.get(`${this.BASE_URL}/limite-adicional-permitido`, { ...options, params }).pipe(
      catchError((e) => this.handleError(e))
    ) as Observable<LimiteAdicionalTrancheAgenteFinanceiro[]>;
  }

}